import { TMediaTablesState } from './types'

export default {
  loading: true,
  energy_consumption: null,
  energy_generation: null,
  water_consumption: null
} as TMediaTablesState
